import React from 'react';
import Notification from '../Notification';
import { formatToGroupedThousands } from '../../utils/number';

export default function SearchResultLimitNotice({
  currentPage,
  maxPages,
  total,
  maxPapers,
}) {
  if ((parseInt(currentPage, 10) === maxPages) && (total > maxPapers)) {
    return (
      <div className="text-center" data-name="top-papers-notification">
        <Notification>
          Showing the First {maxPapers} of {formatToGroupedThousands(total)} papers
        </Notification>
      </div>
    );
  }

  return null;
}



// WEBPACK FOOTER //
// ./src/universal/ui/components/SearchResults/SearchResultLimitNotice.js